var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "view-point-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: "任務維護",
            visible: _vm.dialogVisible,
            width: "63%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.branchLoading,
                      expression: "branchLoading",
                    },
                  ],
                  ref: "form",
                  attrs: {
                    model: _vm.taskForm,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "發佈日期" } },
                    [_c("el-tag", [_vm._v(_vm._s(_vm.taskForm.deployDate))])],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "目標環境",
                        prop: "env",
                        rules: [
                          {
                            required: true,
                            message: "請選擇目標環境",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "header-search-select",
                          attrs: {
                            placeholder: "請選更新類型",
                            "default-first-option": "",
                          },
                          model: {
                            value: _vm.taskForm.env,
                            callback: function ($$v) {
                              _vm.$set(_vm.taskForm, "env", $$v)
                            },
                            expression: "taskForm.env",
                          },
                        },
                        _vm._l(_vm.envOptions, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { value: item.id, label: item.desc },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _c("i", { staticClass: "el-icon-edit" }),
                              ]),
                              _c(
                                "span",
                                {
                                  style: {
                                    float: "right",
                                    color: item.color,
                                    "font-size": "13px",
                                  },
                                },
                                [_vm._v(_vm._s(item.desc))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "儲存庫(Repo)",
                        prop: "repo",
                        rules: [
                          {
                            required: true,
                            message: "請選擇儲存庫",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "header-search-select",
                          attrs: {
                            filterable: "",
                            placeholder: "請選取儲存庫",
                            "default-first-option": "",
                          },
                          on: { change: _vm.onRepoChange },
                          model: {
                            value: _vm.taskForm.repo,
                            callback: function ($$v) {
                              _vm.$set(_vm.taskForm, "repo", $$v)
                            },
                            expression: "taskForm.repo",
                          },
                        },
                        _vm._l(_vm.repos, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { value: item, label: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "分支(branch)",
                        prop: "branch",
                        rules: [
                          {
                            required: true,
                            message: "請選擇分支",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "header-search-select",
                          attrs: {
                            filterable: "",
                            placeholder: "請選取分支",
                            "value-key": "name",
                          },
                          on: { change: _vm.onBranchChange },
                          model: {
                            value: _vm.taskForm.branch,
                            callback: function ($$v) {
                              _vm.$set(_vm.taskForm, "branch", $$v)
                            },
                            expression: "taskForm.branch",
                          },
                        },
                        _vm._l(_vm.branchOptions, function (item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { value: item, label: item.name },
                          })
                        }),
                        1
                      ),
                      _c("el-button", {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-left": "10px",
                        },
                        attrs: {
                          loading: _vm.branchLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getBranchs(_vm.taskForm.repo)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "服務(Service)",
                        prop: "service",
                        rules: [
                          {
                            required: true,
                            message: "請選擇服務",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "header-search-select",
                          attrs: {
                            filterable: "",
                            placeholder: "請選取服務",
                            "default-first-option": "",
                          },
                          model: {
                            value: _vm.taskForm.service,
                            callback: function ($$v) {
                              _vm.$set(_vm.taskForm, "service", $$v)
                            },
                            expression: "taskForm.service",
                          },
                        },
                        _vm._l(_vm.serviceOptions, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { value: item, label: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "sha" } },
                    [
                      _c("el-input", {
                        staticClass: "readonly-input",
                        staticStyle: { width: "70%" },
                        attrs: { readonly: "", placeholder: "Git Commit sha" },
                        model: {
                          value: _vm.taskForm.sha,
                          callback: function ($$v) {
                            _vm.$set(_vm.taskForm, "sha", $$v)
                          },
                          expression: "taskForm.sha",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Commit Info" } },
                    [
                      _vm.branchInfo
                        ? _c(
                            "el-descriptions",
                            {
                              attrs: {
                                title: "",
                                direction: "vertical",
                                column: 3,
                                border: "",
                              },
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "branch" } },
                                [_vm._v(_vm._s(_vm.branchInfo.branch))]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "committer" } },
                                [_vm._v(_vm._s(_vm.branchInfo.committer))]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "date" } },
                                [_vm._v(_vm._s(_vm.branchInfo.date))]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "message" } },
                                [
                                  _c("el-tag", { attrs: { size: "small" } }, [
                                    _vm._v(_vm._s(_vm.branchInfo.message)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "發佈類型" } },
                    [
                      _c(
                        "el-row",
                        { staticClass: "row-bg", attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "header-search-select",
                                  attrs: {
                                    placeholder: "請選更新類型",
                                    "default-first-option": "",
                                  },
                                  model: {
                                    value: _vm.taskForm.deployType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.taskForm, "deployType", $$v)
                                    },
                                    expression: "taskForm.deployType",
                                  },
                                },
                                _vm._l(_vm.deployTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { value: item.id, label: item.desc },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 15 } }, [
                            _vm.taskForm.deployType == 2
                              ? _c(
                                  "div",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": _vm.datePickerOptions,
                                        type: "date",
                                        placeholder: "預定日期",
                                      },
                                      model: {
                                        value: _vm.taskForm.deployDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.taskForm,
                                            "deployDate",
                                            $$v
                                          )
                                        },
                                        expression: "taskForm.deployDate",
                                      },
                                    }),
                                    _c("el-time-select", {
                                      attrs: {
                                        "picker-options": _vm.timePickOptions,
                                        placeholder: "選擇時間",
                                      },
                                      model: {
                                        value: _vm.taskForm.deployTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.taskForm,
                                            "deployTime",
                                            $$v
                                          )
                                        },
                                        expression: "taskForm.deployTime",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.taskForm.deployType == 3
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-right": "5px" },
                                      },
                                      [_vm._v("每日")]
                                    ),
                                    _c("el-time-select", {
                                      attrs: {
                                        "picker-options": {
                                          start: "00:00",
                                          step: "00:10",
                                          end: "23:50",
                                        },
                                        placeholder: "選擇時間",
                                      },
                                      model: {
                                        value: _vm.taskForm.deployTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.taskForm,
                                            "deployTime",
                                            $$v
                                          )
                                        },
                                        expression: "taskForm.deployTime",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: _vm.taskForm.id ? "success" : "primary" },
                  on: { click: _vm.saveData },
                },
                [_vm._v(_vm._s(_vm.taskForm.id ? "再次執行" : "確 定"))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              staticStyle: {
                display: "flex",
                "align-items": "flex-end",
                gap: "0 8px",
              },
              attrs: { "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.addData },
                    },
                    [_vm._v("新增任務")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "觸發來源", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              effect: "plain",
                              type:
                                scope.row.triggeredBy == "ita"
                                  ? "success"
                                  : "danger",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.triggeredBy))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "日期", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.deployDate) +
                            " " +
                            _vm._s(scope.row.deployTime) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.getProcessHandler(
                          scope.row.deployTaskProcess,
                          "message"
                        )
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm._f("statusFilter")(
                                    scope.row.status
                                  ),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("statusDescFilter")(
                                          scope.row.status
                                        )
                                      )
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  disabled: false,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.alertErrorMsg(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("statusDescFilter")(
                                        scope.row.status
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "環境" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.env) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "儲存庫", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.repository) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "分支", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.branch) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "服務", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.service) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "發佈類型", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("statusFilter")(
                                scope.row.deployType
                              ),
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.deployTypeOptions.find(function (option) {
                                    return option.id === scope.row.deployType
                                  }).desc
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "Process", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "table",
                          {
                            staticClass: "custom-table",
                            attrs: { border: "1" },
                          },
                          [
                            _c("tr", [
                              _c("th", [_vm._v("checkout")]),
                              _c("th", [_vm._v("publish")]),
                              _c("th", [_vm._v("deploy")]),
                              _c("th", [_vm._v("updated")]),
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "checkout"
                                  )
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-check process-checked",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "publish"
                                  )
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-check process-checked",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "deploy"
                                  )
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-check process-checked",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "updated"
                                  )
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-check process-checked",
                                        }),
                                      ])
                                    : _vm._e(),
                                  scope.row.deployType == 0 &&
                                  _vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "deploy"
                                  ) &&
                                  !_vm.getProcessHandler(
                                    scope.row.deployTaskProcess,
                                    "updated"
                                  ) &&
                                  scope.row.status == 1
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                disabled: false,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updated(scope.row)
                                                },
                                              },
                                            },
                                            [_vm._v("更新")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deployType == 2 &&
                                  scope.row.status != 3
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-timer process-checked",
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              disabled: false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "建立時間", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.buildDate.replace("T", " ")) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "建立者", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.buildExecutor) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "guid", width: "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.guid) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "更新時間", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.updateDate.replace("T", " ")) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "更新者", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.updateExecutor) + " "),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }